export const RolesIcon = () => {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2532_67041)">
        <path
          d="M26.25 50C35.2246 50 42.5 42.7246 42.5 33.75C42.5 24.7754 35.2246 17.5 26.25 17.5C17.2754 17.5 10 24.7754 10 33.75C10 42.7246 17.2754 50 26.25 50Z"
          stroke="#A5A5A5"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.20312 62.4997C5.70028 58.6602 9.11686 55.5052 13.1427 53.3212C17.1685 51.1371 21.6761 49.9932 26.2563 49.9932C30.8364 49.9932 35.344 51.1371 39.3698 53.3212C43.3956 55.5052 46.8122 58.6602 49.3094 62.4997"
          stroke="#A5A5A5"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M53.75 50C58.3299 49.9973 62.8378 51.1394 66.8639 53.3225C70.8901 55.5056 74.3067 58.6603 76.8031 62.5"
          stroke="#A5A5A5"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M47.7188 18.6562C49.9416 17.7697 52.3329 17.385 54.7216 17.5298C57.1104 17.6745 59.4377 18.3451 61.5372 19.4935C63.6368 20.642 65.4568 22.2401 66.8671 24.1735C68.2775 26.1069 69.2433 28.3279 69.6958 30.6779C70.1482 33.0279 70.076 35.4488 69.4843 37.7677C68.8926 40.0865 67.7961 42.2461 66.273 44.092C64.7499 45.9379 62.838 47.4246 60.6737 48.4459C58.5094 49.4672 56.1463 49.9979 53.7531 50"
          stroke="#A5A5A5"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2532_67041">
          <rect width="80" height="80" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
